import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import DashboardSvg from '../../../assets/icons/nav/dashboard.svg?raw';

export const DashboardIcon = (props) => <CustomSVG svg={DashboardSvg} preserveColors {...props} />;
